export default __webpack_public_path__ + "static/media/lunch.bbcb98ac.png";